import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import { plugin, defaultConfig } from '@formkit/vue';
import App from './App.vue';
import router from './router';
import './assets/main.css';

Bugsnag.start({
  apiKey: import.meta.env.BGSNG_API_KEY,
  appVersion: import.meta.env.RAM_APP_VERSION,
  releaseStage: import.meta.env.MODE,
  plugins: [new BugsnagPluginVue()],
});

const bugsnagVue = Bugsnag.getPlugin("vue")!;

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(bugsnagVue);
app.use(router);
app.use(plugin, defaultConfig);

app.directive('limit', {
  mounted(el: HTMLElement, binding: any) {
    const input = el.querySelector('input') 
    if (!input) return

    input.addEventListener('input', (event: any) => {
      const limit = binding.value 
      if (event.target.value.length > limit) {
        event.target.value = event.target.value.slice(0, limit)
        event.target.dispatchEvent(new Event('input')) 
      }
    })
  }
})

app.mount('#app');

console.info(`🎉SBSA Pickup Point v${import.meta.env.RAM_APP_VERSION}`);